
import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import {t} from "react-switch-lang";
import {deleteDepartments} from "../../../../services/administration/departments/departments";
import {Toast} from "../../../../utils/sweetAlert";
import Swal from "sweetalert2";

const DeleteDepartment = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleSubmit = (event) => {
    setIsButtonDisabled(true);
    event.preventDefault();
    deleteDepartments(props.data.id)
      .then((res) => {
        Toast.fire({
          icon: "success",
          title: `${t("message.successDelete")}`,
        });
        props.setRowChanged();
        props.toggleModal();
        setIsButtonDisabled(false);
      })
      .catch((r) => {
        if (r?.response?.data?.code === 'department-could-not-be-deleted') {
          Swal.fire({
            text: t('message.departmentCannotDelete'),
            icon: 'error',
          });
        } else {
          Swal.fire({
            text: `${t("message.errorApi")}`,
            icon: "error",
            confirmButtonText: "OK",
          });
          setIsButtonDisabled(false);
        }
      });
  };

  return (
    <Form
      onSubmit={(e) => handleSubmit(e)}
      noValidate
      className="d-flex justify-content-between">
      <Button className="primary deleteButton" disabled={isButtonDisabled}>
        {t("buttons.deleteBtn")}{" "}
      </Button>
    </Form>
  );
};

export default DeleteDepartment;
